import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Grid, GridColumn, Link, Text, Theme } from "sprint-common-web";

import { RecordType } from "../../../../../../../../common/types/RecordType";
import { AssociateContentStandaloneForm } from "../../../../../../../../content-ingestion/common/content/forms/AssociateContentStandaloneForm";
import { getBulkEditCloudAssetContentPageHref } from "../../../../../../../AssetsRoutes";
import { CloudAssetDetails } from "../../../../../CloudAssetDetails";
import { mapToContentAssociationFormState, useEditCloudAssetContentForm } from "./useEditCloudAssetContentForm";

export const EditCloudAssetContentForm: React.FC = () => {
    const {
        setDefaultContentState,
        defaultContentState,
        isDefaultContentLoading,
        setIsDefaultContentLoading,
        backToAssetDetails,
        assetDetails,
        assetId,
        onSubmit,
        validate
    } = useEditCloudAssetContentForm();

    const history = useHistory();

    useEffect(() => {
        if (assetDetails) {
            setDefaultContentState(mapToContentAssociationFormState(assetDetails));
            setIsDefaultContentLoading(false);
        }
    }, [assetDetails]);

    const moveToBulkEditContentPage = () => {
        history.push(getBulkEditCloudAssetContentPageHref(assetId));
    };

    return (
        <>
            <AssociateContentStandaloneForm
                formTitle="Edit content"
                onSubmitValidate={validate}
                onSubmit={onSubmit}
                onCancel={backToAssetDetails}
                isDefaultContentLoading={isDefaultContentLoading}
                defaultContentState={defaultContentState}
                infoMessage={getInfoMessage(assetDetails)}
            />
            <Grid>
                <GridColumn sm={3}>
                    <Text variant="smallPlus">
                        Need to move the whole asset group instead?{" "}
                        <Link
                            onClick={moveToBulkEditContentPage}
                            styles={{ root: { textDecoration: "underline", color: Theme.semanticColors.linkHovered } }}
                        >
                            Bulk edit content
                        </Link>
                    </Text>
                </GridColumn>
            </Grid>
        </>
    );
};

const getInfoMessage = (assetDetails: CloudAssetDetails | undefined) => {
    if (!assetDetails) {
        return "";
    }

    if (assetDetails.type === RecordType.Video) {
        return videoMessage;
    }

    return infoMessageBase;
};

const infoMessageBase =
    "New asset will be created on submit. Please make sure all information is correct. Changes will be applied only to the current asset, other related assets must be updated manually.";

const videoMessage =
    "New assets will be created on submit. Please make sure all information is correct. If a video asset has an active proxy audio asset, editing a video asset will also create a separate audio asset.";
